import usePayInBPay from './usePayInBPay';

export { usePayInBPay };
